<!-- Spinner while term changes list is being loaded -->
<div *ngIf="loading && !loadError" class="pd-loader">
    <hc-progress-spinner color="purple" [diameter]="75"></hc-progress-spinner>
</div>

<!-- Error loading content -->
<div *ngIf="!loading && loadError" class="pd-permission-error">
    <hc-icon fontSet="fa" fontIcon="fa-warning"></hc-icon>
    There was an error loading the change log. Click below try again.
    <button hc-button size="lg" (click)="loadTermChanges()">Reload Changes</button>
</div>

<div class="pd-admin-terminology-change-log" [hidden]="loadError || loading">
    <table hc-table [borders]="false" [dataSource]="adminTerminologyChangesDataSource" hcSort>
        <!-- Date Column -->
        <ng-container hcColumnDef="date">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="dateHeader">Date</th>
            <td hc-cell *hcCellDef="let element">{{ element.date | date: 'shortDate' }}</td>
        </ng-container>

        <!-- User Column -->
        <ng-container hcColumnDef="user">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="userHeader">User</th>
            <td hc-cell *hcCellDef="let element">{{ element.user }}</td>
        </ng-container>

        <!-- Item Column -->
        <ng-container hcColumnDef="item">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="itemHeader">ID</th>
            <td hc-cell *hcCellDef="let element">{{ element.item }}</td>
        </ng-container>

        <!-- Field Column -->
        <ng-container hcColumnDef="field">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="fieldHeader">Field</th>
            <td hc-cell *hcCellDef="let element">{{ element.field }}</td>
        </ng-container>

        <!-- Previous Value Column -->
        <ng-container hcColumnDef="previous">
            <th hc-header-cell *hcHeaderCellDef id="fieldHeader">Previous Value</th>
            <td hc-cell *hcCellDef="let element">{{ element.previous }}</td>
        </ng-container>

        <!-- Change Value Column -->
        <ng-container hcColumnDef="change">
            <th hc-header-cell *hcHeaderCellDef id="fieldHeader">Change Value</th>
            <td hc-cell *hcCellDef="let element">{{ element.update }}</td>
        </ng-container>

        <tr hc-header-row *hcHeaderRowDef="changesDisplayedColumns"></tr>
        <tr hc-row *hcRowDef="let row; columns: changesDisplayedColumns"></tr>
    </table>

    <hc-pagination [length]="changesListLength" [pageSize]="changesPageSize"></hc-pagination>
</div>